import { useCoachAuthContext } from "./useCoachAuthContext";
import { Link,useNavigate } from "react-router-dom";

export const useCoachLogout = () => {

    const { dispatch } = useCoachAuthContext();
    const navigate = useNavigate();

    
    const logout = () => {
     //remove user from local storage
     localStorage.removeItem('coach');
     //dispatch logout action
     dispatch({type: 'COACH_LOGOUT'});
     navigate('/coach/login');
     
    }
    return { logout };
}